module.exports = __webpack_public_path__ + "static/img/index-icon9@2x.fad3c4e2.png";